import { render, staticRenderFns } from "./FontsList.vue?vue&type=template&id=27ed5fbf&"
import script from "./FontsList.vue?vue&type=script&lang=js&"
export * from "./FontsList.vue?vue&type=script&lang=js&"
import style0 from "./FontsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports